// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-app_node_modules_pnpm_events_3_3_0_node_modules_events_events_js-app_node_modules_pnp-9ad167","externals_ember_-internals_metal_js-externals_ember_application_namespace_js-externals_ember_-0c3f86"], () => (__webpack_require__("./assets/back-office.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
